<template>
  <div class="active-exports" v-if="activeExports.length > 0">
    <div class="active-exports__status-wrapper">
      <div class="active-exports__status" v-if="activeExports.length < 3">
        <div
          class="active-exports__status-icon"
          v-html="activeExportsIcon"
        ></div>
        <div class="active-exports__status-text">
          {{ $t('active-exports.status-label') }}
        </div>
      </div>
      <div
        class="active-exports__status active-exports__status--clear"
        @click="clearExportQueue"
      >
        <div class="active-exports__status-icon">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8.5" cy="8.5" r="8.5" fill="#DBE7FD" />
            <circle
              cx="8.5"
              cy="8.5"
              r="3.9"
              stroke="#64748B"
              stroke-width="1.2"
            />
            <line
              x1="5.97171"
              y1="5.96364"
              x2="11.8222"
              y2="11.1378"
              stroke="#64748B"
              stroke-width="1.2"
            />
          </svg>
        </div>
        <div class="active-exports__status-text">
          {{ $t('active-exports.clear-label') }}
        </div>
      </div>
    </div>

    <div class="active-exports__text">
      {{ activeExportsText }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CLEAR_EXPORT_QUEUE } from '@vue-app/store/const/actions-types'

export default {
  name: 'HeaderExportBlock',
  data() {
    return {}
  },
  computed: {
    ...mapState(['activeExports']),
    activeExportsIcon() {
      let _inProcess = `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="8.5" fill="#DBE7FD"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.00019 10.6045C5.30341 10.6045 5.54921 10.8406 5.54921 11.132V12.2528C5.54921 12.3111 5.57331 12.367 5.61621 12.4083C5.65911 12.4495 5.7173 12.4726 5.77797 12.4726H11.2224C11.2831 12.4726 11.3413 12.4495 11.3842 12.4083C11.4271 12.367 11.4512 12.3111 11.4512 12.2528V11.132C11.4512 10.8406 11.697 10.6045 12.0002 10.6045C12.3034 10.6045 12.5492 10.8406 12.5492 11.132V12.2528C12.5492 12.5909 12.4094 12.9152 12.1606 13.1542C11.9118 13.3933 11.5743 13.5276 11.2224 13.5276H5.77797C5.42608 13.5276 5.0886 13.3933 4.83978 13.1542C4.59096 12.9152 4.45117 12.5909 4.45117 12.2528V11.132C4.45117 10.8406 4.69698 10.6045 5.00019 10.6045Z" fill="#64748B"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.55631 6.86797C6.77072 7.07396 7.11834 7.07396 7.33274 6.86797L8.50008 5.74644L9.66742 6.86797C9.88183 7.07396 10.2294 7.07396 10.4439 6.86797C10.6583 6.66198 10.6583 6.328 10.4439 6.12201L8.8883 4.6275C8.78534 4.52858 8.64569 4.47301 8.50008 4.47301C8.35447 4.47301 8.21483 4.52858 8.11187 4.6275L6.55631 6.12201C6.34191 6.328 6.34191 6.66198 6.55631 6.86797Z" fill="#64748B"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50019 10.7588C8.80341 10.7588 9.04921 10.5226 9.04921 10.2313V5.00055C9.04921 4.70923 8.80341 4.47308 8.50019 4.47308C8.19698 4.47308 7.95117 4.70923 7.95117 5.00055V10.2313C7.95117 10.5226 8.19698 10.7588 8.50019 10.7588Z" fill="#64748B"/>
        </svg>`

      let _finished = `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="8.5" r="8.5" fill="#64748B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6553 5.13866C12.0186 5.38368 12.1092 5.86923 11.8577 6.22316L7.75282 12L4.27938 9.09929C3.94392 8.81914 3.90507 8.32709 4.19261 8.00026C4.48014 7.67342 4.98518 7.63557 5.32063 7.91571L7.44713 9.69158L10.5422 5.33584C10.7937 4.98191 11.292 4.89363 11.6553 5.13866Z" fill="white"/></svg>`

      if (this.activeExports.length === 0) {
        return _finished
      }

      if (this.activeExports.length > 1) {
        let _inProcessCount = this.activeExports.filter(
          (_export) => _export.report_status_slug === 'new'
        ).length

        if (_inProcessCount > 0) {
          return _inProcess
        }

        return _finished
      }

      let _activeExport = this.activeExports[0]

      if (_activeExport.report_status_slug === 'new') {
        return _inProcess
      } else {
        return _finished
      }
    },
    activeExportsText() {
      if (this.activeExports.length === 0) {
        return this.$t('active-exports.finished')
      }

      if (this.activeExports.length > 0) {
        let _inProcessCount = this.activeExports.filter(
          (_export) => _export.report_status_slug === 'new'
        ).length

        if (_inProcessCount > 0) {
          return this.$t('active-exports.in-process', {
            count: _inProcessCount,
          })
        }

        return this.$t('active-exports.finished')
      }

      return this.$t('active-exports.finished')
    },
  },
  methods: {
    clearExportQueue() {
      this.$store.commit(CLEAR_EXPORT_QUEUE)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
.active-exports {
  background: #ffffff;
  box-shadow: 0px 8px 35px rgba(225, 235, 253, 0.76);
  border-radius: 12px;
  padding: 9px 7px;
  display: flex;
  align-items: center;
  border: 1px solid;
  border-image-source: linear-gradient(0deg, #f4f3fc, #f4f3fc);
  &__status {
    position: relative;
    background: #f5f8fd;
    border-radius: 35px;
    padding: 1px 10px 1px 1px;
    display: flex;
    align-items: center;

    &-wrapper {
      position: relative;
    }

    &--clear {
      cursor: pointer;
    }

    & + &--clear {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;

      &:hover {
        opacity: 1;
      }
    }

    &-icon {
      width: 17px;
      height: 17px;
      margin-right: 5px;
    }

    &-text {
      font-weight: 600;
      font-size: 10px;
      line-height: 12px;
      color: #64748B;
    }
  }

  &__text {
    font-weight: 500;
    font-size: 10px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #67768a;
    margin-left: 11px;
    white-space: nowrap;
  }

  &__reset {
  }
}
</style>
